import { checkExpGroupClaimEpicReducer, checkWorkspaceClaimEpicReducer } from "./UserAccess.ducks.js";
const getDefaultUserAccessReducerStateById = () => {
  return {
    workspaces: {}
  };
};
const getDefaultUserAccessReducerState = () => {
  return {
    workspaceClaims: {},
    experimentationGroupClaims: {}
  };
};
const UserAccessReducerById = (state = getDefaultUserAccessReducerStateById(), action) => {
  state = checkExpGroupClaimEpicReducer.reduxChange(state, action);
  state = checkWorkspaceClaimEpicReducer.reduxChange(state, action);
  return state;
};
const UserAccessReducersMapObject = {
  userAccess: UserAccessReducerById
};
export {
  UserAccessReducerById,
  UserAccessReducersMapObject,
  UserAccessReducersMapObject as default,
  getDefaultUserAccessReducerState,
  getDefaultUserAccessReducerStateById
};
//# sourceMappingURL=UserAccess.reducer.js.map
